import { ProjectsAction, ProjectsActionTypes, ProjectsState } from "../types/projectsList"

const initialState: ProjectsState = {
  projects: [],
  loaded: false,
  error: null,
}

export const projectListReducer = (state = initialState, action: ProjectsAction): ProjectsState => {
  switch (action.type) {
    case ProjectsActionTypes.FETCH_PROJECTS_LIST:
      return {
        ...state,
        loaded: true,
      }
    case ProjectsActionTypes.FETCH_PROJECTS_LIST_SUCCESS:
      return {
        ...state,
        loaded: false,
        projects: action.payload,
      }
    case ProjectsActionTypes.FETCH_PROJECTS_LIST_ERROR:
      return {
        ...state,
        error: action.payload,
      }
    default:
      return state
  }
}
